import React from "react";

import { AlignedRichTextBlock } from "@reactivated";

import { AlignedRichTextBlock as Base } from "@thelabnyc/thelabui/src/components/AlignedRichTextBlock";
import { classNames } from "@thelabnyc/thelabui/src/utils/styles";

import { RichText } from "../RichText";

import heroStyles from "../BigHero/index.module.scss";
import richTextStyles from "../RichText/rich-text.module.scss";
import styles from "./index.module.scss";

interface CustomCss extends React.CSSProperties {
    "--extra-padding-top": string;
    "--extra-padding-bottom": string;
}

export function AlignedRichText({ value }: { value: AlignedRichTextBlock }) {
    return (
        <Base
            attrs={{
                className: classNames([
                    [styles[value.theme ?? "match"], true],
                    [
                        heroStyles[value.overlay ?? "overlayOff"],
                        !!value.overlay,
                    ],
                    [
                        richTextStyles.largeHeadings,
                        value.text_size == "textSizeLarge",
                    ],
                ]),
                style: {
                    "--extra-padding-top": `var(--spacer-block-${value.space_before})`,
                    "--extra-padding-bottom": `var(--spacer-block-${value.space_after})`,
                } as CustomCss,
            }}
            value={value}
            dependencies={{ RichTextBlock: RichText }}
        />
    );
}
